import { render } from "./VgtGlobalSearch.vue?vue&type=template&id=3e993d4e"
import script from "./VgtGlobalSearch.vue?vue&type=script&lang=js"
export * from "./VgtGlobalSearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__